// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import AMapLoader from '@amap/amap-jsapi-loader'

window._AMapSecurityConfig = {
  // securityJsCode: '4981945b8c52c8ddb25aae5b7c03b6e7'   // 密钥
  securityJsCode: '60e7ae3dcd27369de04dc90df376807d'
}

AMapLoader.load({
  // key: "09ed4422ffd519d80a78be5b162ef9a9",
  key: '9f2dbb51dfac885d3b3043f6317628f6',
  version: "2.0",
}).then((AMap) => {
  //JS API 加载完成后获取AMap对象
  Vue.prototype.$AMap = AMap;
}).catch((e) => {
    console.error(e); //加载错误提示
  });

import http from './utils/requestUtils'
Vue.prototype.$http = http

import authHttp from './utils/authRequestUtils'
Vue.prototype.$authHttp = authHttp

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js